export default __webpack_public_path__ + "static/media/noti-bg.4cfaf35c.png";